module.exports = __webpack_public_path__ + "assets/Infrastructure_inactive_icn@1x.1e8801fc.svg";